module.exports = JBrowseExports["@mui/material/styles"];